import { render, staticRenderFns } from "./Indr.vue?vue&type=template&id=505548a8&"
import script from "./Indr.vue?vue&type=script&lang=js&"
export * from "./Indr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports